import { isPointInPolygon } from "../../selectionAreas";
import type { IsElementInsideRoom } from "./types";

// Bbox-centre rule shared by the map scoping and the per-room export, so both always agree.
export const isElementInsideRoom: IsElementInsideRoom = ({ element, room }) => {
  if (room.pageIndex !== (element.page ?? 0)) return false;
  const bboxCenter = {
    x: (element.bbox.x1 + element.bbox.x2) / 2,
    y: (element.bbox.y1 + element.bbox.y2) / 2,
  };
  return isPointInPolygon({ point: bboxCenter, ring: room.points });
};
